const EVENT_TYPES = {
  MAKE_PAYMENT: 'make_payment',
  PAYMENT_COMPLETED: 'payment_completed',
  ADD_PAYMENT_METHOD: 'add_payment_method',
  REMOVE_PAYMENT_METHOD: 'remove_payment_method'
}

const dispatchMakePaymentEvent = (payload) => {
  let event = new CustomEvent(EVENT_TYPES.MAKE_PAYMENT, {
    detail: payload
  });

  window.dispatchEvent(event);
}
// TODO these 2 are only for test
const addMakePaymentEvent = (callback) => {
  window.addEventListener(EVENT_TYPES.MAKE_PAYMENT, callback);
}

const removeMakePaymentEvent = (callback) => {
  window.removeEventListener(EVENT_TYPES.MAKE_PAYMENT, callback);
}

const addPaymentCompletedEvent = (callback) => {
  window.addEventListener(EVENT_TYPES.PAYMENT_COMPLETED, callback);
}

const removePaymentCompletedEvent = (callback) => {
  window.removeEventListener(EVENT_TYPES.PAYMENT_COMPLETED, callback);
}

const addAddPaymentMethodEvent = (callback) => {
  window.addEventListener(EVENT_TYPES.ADD_PAYMENT_METHOD, callback);
}

const removeAddPaymentMethodEvent = (callback) => {
  window.removeEventListener(EVENT_TYPES.ADD_PAYMENT_METHOD, callback);
}

const addRemovePaymentMethodEvent = (callback) => {
  window.addEventListener(EVENT_TYPES.REMOVE_PAYMENT_METHOD, callback);
}

const removeRemovePaymentMethodEvent = (callback) => {
  window.removeEventListener(EVENT_TYPES.REMOVE_PAYMENT_METHOD, callback);
}

export {
  dispatchMakePaymentEvent,
  addMakePaymentEvent,
  removeMakePaymentEvent,
  addPaymentCompletedEvent,
  removePaymentCompletedEvent,
  addAddPaymentMethodEvent,
  removeAddPaymentMethodEvent,
  addRemovePaymentMethodEvent,
  removeRemovePaymentMethodEvent
};